module.exports = __webpack_public_path__ + "img/ticket.e536f207.svg";